'use client';
import { btnSoft } from '@/lib/ui';

import { useImpersonation } from '@/contexts/impersonation-context';

export function ImpersonationBanner() {
  const { active, targetEmail, targetName, stopImpersonation } = useImpersonation();

  if (!active) return null;

  const displayName = targetName ? `${targetEmail} (${targetName})` : targetEmail;

  return (
    <div className="fixed top-0 left-0 right-0 z-[200] bg-warning-surface-strong backdrop-blur-sm border-b border-warning-edge text-warning/80 px-4 py-1.5 flex items-center justify-between text-xs">
      <span>
        Viewing as <span className="font-medium text-warning/90">{displayName}</span>
      </span>
      <button
        onClick={stopImpersonation}
        className={`${btnSoft('warning')} rounded px-2.5 py-0.5 text-xs font-medium`}
      >
        Stop
      </button>
    </div>
  );
}
